import { useState, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useNotifier } from '@provider/notifier';
import { EditInput, IconButton, EyeIcon, TrashIcon } from '@ui/kit';
import { Chevron, CSSRefTransition } from '@utils/react';
import { makePreviewLightboxConfig } from '../../../../modals/preview-lightbox.js';
import { courseBuilderStore } from '../../../../state/store.js';
import { sectionCls, goBackCls, separatorCls, headerCls, inputCls, transitionCls, transitionDurationMs } from './_course-page.style.js';
import { Content } from './content.js';
import { Empty } from './empty.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useDeleteCourseMutation } from '../../../../api/mutation.delete.js';
import { useUpdateCourseMutation } from '../../../../api/mutation.update.js';

function CoursePage(props) {
  const notifier = useNotifier();
  const [tmpTitle, titleCallbacks] = useEphemeralTitleInput(props);
  const isEmpty = !props.course.blocks || !props.course.blocks?.length;
  const deleteCourse = useDeleteCourseMutation();
  const goBack = () => {
    courseBuilderStore.dispatch(courseBuilderStore.actions.selectCourseById(undefined));
  };
  return /*#__PURE__*/jsxs("section", {
    className: sectionCls,
    children: [/*#__PURE__*/jsxs("button", {
      className: goBackCls,
      onClick: goBack,
      children: [/*#__PURE__*/jsx(Chevron, {
        className: "chevron",
        inversed: true,
        size: 10
      }), " Mine forl\xF8b"]
    }), /*#__PURE__*/jsx("hr", {
      className: separatorCls
    }), /*#__PURE__*/jsxs("header", {
      className: headerCls,
      children: [/*#__PURE__*/jsx(EditInput, {
        ...titleCallbacks,
        mode: "reveal-on-hover",
        type: "text",
        "aria-label": "Rediger forl\xF8b",
        className: inputCls,
        value: tmpTitle,
        maxLength: 100
      }), /*#__PURE__*/jsxs("div", {
        children: [!isEmpty && /*#__PURE__*/jsx(IconButton, {
          icon: /*#__PURE__*/jsx(EyeIcon, {}),
          label: "Vis forl\xF8b",
          onClick: () => {
            notifier.modal(makePreviewLightboxConfig({
              course: props.course
            }));
          }
        }), /*#__PURE__*/jsx(IconButton, {
          icon: /*#__PURE__*/jsx(TrashIcon, {}),
          label: "Slet forl\xF8b",
          onClick: async () => {
            const confirmed = await notifier.confirm({
              type: "slide-up",
              heading: "Vil du slette forløbet?",
              body: "Bemærk at denne handling ikke kan fortrydes. Hvis du sletter et forløb, der allerede er delt, vil forløbet ikke længere være tilgængeligt for modtageren.",
              labels: {
                ok: "Slet"
              }
            });
            if (confirmed !== "ok") {
              return;
            }
            deleteCourse.mutate(props.course);
            courseBuilderStore.dispatch(courseBuilderStore.actions.selectCourseById(undefined));
          }
        })]
      })]
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: isEmpty ? /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: transitionCls,
        timeout: {
          enter: transitionDurationMs,
          exit: 0
        },
        children: ref => /*#__PURE__*/jsx(Empty, {
          ref: ref
        })
      }, "empty") : /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: transitionCls,
        timeout: {
          enter: transitionDurationMs,
          exit: 0
        },
        children: ref => /*#__PURE__*/jsx(Content, {
          ref: ref,
          course: props.course
        })
      }, "content")
    })]
  });
}
function useEphemeralTitleInput(props) {
  const updateCourse = useUpdateCourseMutation();
  const [tmpTitle, setTmpTitle] = useState(props.course.title);
  const updateBlockTitle = () => {
    // No need to save if nothing has been changed
    if (props.course.title === tmpTitle) {
      return;
    }
    updateCourse.mutate({
      oldCourse: props.course,
      newCourse: {
        ...props.course,
        title: tmpTitle
      },
      options: {
        silent: true
      }
    });
  };
  const onKeyDown = evt => {
    if (evt.key === "Enter") {
      evt.preventDefault();
      evt.currentTarget.blur();
    }
  };
  const onBlur = () => {
    updateBlockTitle();
  };
  useEffect(() => {
    setTmpTitle(props.course.title);
  }, [props.course.title]);
  return [tmpTitle, {
    onKeyDown,
    onBlur,
    onChange: setTmpTitle
  }];
}

export { CoursePage };
//# sourceMappingURL=_course-page.js.map
